import { useState, useCallback } from 'react';
import { PageType } from '../types';

export const useNavigation = (initialPage: PageType = 'dashboard') => {
  const [currentPage, setCurrentPage] = useState<PageType>(() => {
    // Try to restore page from sessionStorage on initial load
    if (typeof window !== 'undefined') {
      const savedPage = sessionStorage.getItem('currentPage');
      return (savedPage as PageType) || initialPage;
    }
    return initialPage;
  });

  const navigate = useCallback((page: PageType) => {
    setCurrentPage(page);
    // Save current page to sessionStorage for persistence
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('currentPage', page);
    }
  }, []);

  return {
    currentPage,
    navigate
  };
};